<template>
<div>
  <div v-if="tabName">
    <ul class="nav nav-tabs nav-tabs-fillup hidden-sm-down"
        data-init-reponsive-tabs="dropdownfx">
      <li v-for="status in tabsList" class="nav-item">
        <a href="#"
           :class="{ active: status==tabName, disabled: isLoading, 'text-muted': isLoading && status != tabName }"
           data-toggle="tab"
           :data-target="status"
           aria-expanded="true"
           @click="selectTab(status)">
          <span>{{ getTabNameByStatus(status) }}
            <button class="btn btn-sm btn-rounded number-by-status" :class="numberColorByStatus(status)" >{{ numberByStatus[status] }}</button>
          </span>
        </a>
      </li>
    </ul>
  </div>
</div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'

  export default {
    name: 'TabHeader',
    props: ['isManager', 'numberByStatus', 'tabsList', 'isLoading'],
    computed: {
      ...mapGetters({
        tabName: 'offers/selectedTab',
        currentUser: 'auth/currentUser'
      }),
    },
    methods: {
      selectTab: function(name){
        if(this.isLoading) {
          return;
        }

        this.$emit('offersTabChanged', name)
      },
      getTabNameByStatus(name) {
        return this.isManager? this.$i18n.t(`Offers.status.manager.${name}`): this.$i18n.t(`Offers.status.candidate.${name}`)
      },
      numberColorByStatus(name) {
        return name + '-color'
      }
    },
    mounted: function() {
      this.changeTabOnMobile()
    },
    updated: function() {
      this.changeTabOnMobile()
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/pages/_var.scss';
  .number-by-status {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12.9px;
    line-height: 5px;
    color: white;
  }
  .all-color, .expired-color{
    background-color: $color-all;
  }
  .published-color{
    background-color: $color-published;
  }
  .waiting-color{
    background-color: $color-waiting;
  }
  .validated-color, .expired_and_validated-color{
    background-color: $color-validated;
  }
  .draft-color{
    background-color: $color-draft;
  }
  .expired_and_not_validated-color{
    background-color: $color-expired;
  }
  .cancelled-color{
    background-color: $color-cancelled;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/TabHeader.vue